import { useState, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { isInternalSelector } from '../../redux/user';
import { useTabbedNav } from '../../utils/hooks/useNav';

interface MmmPageNav<T extends string> {
  key: T;
  label: string;
  requiresInternal?: boolean; // drop unless isInternal
}

interface UseMmmPageOptions<T extends string> {
  baseURL: string;
  navs: readonly MmmPageNav<T>[];
}

export const useMmmPage = <T extends string>({ baseURL, navs }: UseMmmPageOptions<T>) => {
  const isInternal = useSelector(isInternalSelector);

  const gatedNavs = navs
    .filter(nav => !nav.requiresInternal || isInternal)
    .map(nav => ({ label: nav.label, key: nav.key }));

  const { tab, goToTab } = useTabbedNav({
    baseURL,
    defaultKey: navs[0].key,
    navs: gatedNavs.map(nav => nav.key)
  });

  const [scenarioHeaderActions, setScenarioHeaderActions] = useState<ReactElement | null>(null);

  return {
    tab,
    goToTab,
    navs: gatedNavs,
    isInternal,
    scenarioHeaderActions,
    setScenarioHeaderActions
  };
};
